// AuditoriaTabXL - Sprint 44 Fase 3 Vista 3.
// Tab "Auditoria": timestamps created_at / updated_at en formato es-CO.
// Si el producto aun no se guardo (isEdit=false), se muestra placeholder.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';

const CSS_ID = 'xl-prod-audit-css';
const CSS = `
.xl-audit {
  font-family: var(--xl-font-sans);
  color: var(--xl-color-text);
}
.xl-audit__empty {
  padding: 32px 16px;
  text-align: center;
  color: var(--xl-color-text-muted);
  font-size: 13px;
}
.xl-audit__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
@media (max-width: 720px) { .xl-audit__grid { grid-template-columns: 1fr } }
.xl-audit__card {
  background: var(--xl-color-surface-alt);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-md);
  padding: 14px 16px;
}
.xl-audit__label {
  font-size: 10px; text-transform: uppercase; letter-spacing: 0.06em;
  color: var(--xl-color-text-muted); font-weight: 600;
  margin-bottom: 4px;
}
.xl-audit__value {
  font-family: var(--xl-font-mono);
  font-size: 13px;
  color: var(--xl-color-text);
}
`;

function fmtFecha(iso) {
  if (!iso) return '\u2014';
  try {
    return new Date(iso).toLocaleString('es-CO');
  } catch (_) {
    return iso;
  }
}

export default function AuditoriaTabXL({ form, isEdit }) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);

  if (!isEdit) {
    return (
      <div className="xl-audit">
        <div className="xl-audit__empty">
          La auditoria aparecera despues de guardar el producto.
        </div>
      </div>
    );
  }

  return (
    <div className="xl-audit">
      <div className="xl-audit__grid">
        <div className="xl-audit__card">
          <div className="xl-audit__label">Creado</div>
          <div className="xl-audit__value">{fmtFecha(form.created_at)}</div>
        </div>
        <div className="xl-audit__card">
          <div className="xl-audit__label">Ultima actualizacion</div>
          <div className="xl-audit__value">{fmtFecha(form.updated_at)}</div>
        </div>
      </div>
    </div>
  );
}
